"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchJsonLd_1 = require("./fetchJsonLd");
exports.fetchJsonLd = fetchJsonLd_1.default;
var parseHydraDocumentation_1 = require("./parseHydraDocumentation");
exports.parseHydraDocumentation = parseHydraDocumentation_1.default;
exports.getDocumentationUrlFromHeaders = parseHydraDocumentation_1.getDocumentationUrlFromHeaders;
//# sourceMappingURL=index.js.map